import script from "./teachingFeatureSection.vue?vue&type=script&setup=true&lang=js"
export * from "./teachingFeatureSection.vue?vue&type=script&setup=true&lang=js"

import "./teachingFeatureSection.vue?vue&type=style&index=0&id=2b6f7816&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6f7816"]])

export default __exports__